import React from "react";

import CompanyAvatar from "@/components/companyAvatar";
import UserAvatar from "@/components/userAvatar";
import { Landmark } from "lucide-react";

const Avatar = ({ id, name, type, className, size, title, onClick }) => {
  switch (type) {
    case "capitalInsurance":
      return (
        <CompanyAvatar
          companyId={id}
          companyName={name}
          className={className}
          bgIcon={<Landmark className="mt-[-2px]" strokeWidth={1} size={32} />}
          size={size}
          title={title}
          onClick={onClick}
        />
      );
    case "company":
      return (
        <CompanyAvatar
          companyId={id}
          companyName={name}
          className={className}
          size={size}
          title={title}
          onClick={onClick}
        />
      );
    default:
      return (
        <UserAvatar
          userId={id}
          userName={name}
          className={className}
          size={size}
          title={title}
          onClick={onClick}
        />
      );
  }
};

export default Avatar;
